import { Component, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  standalone: false,
  templateUrl: './confirm-save-modal.component.html',
  styleUrls: ['./confirm-save-modal.component.scss'],
})
export class ConfirmSaveModalComponent {
  @Input() title = 'Guardar cambios';
  @Input() message = 'Tienes cambios sin guardar. Quieres guardar antes de salir?';
  @Input() confirmText = 'Guardar';
  @Input() cancelText = 'Cancelar';

  constructor(private modalController: ModalController) {}

  cancel(): void {
    this.modalController.dismiss(false);
  }

  confirm(): void {
    this.modalController.dismiss(true);
  }
}
